export const availableCountries = [
  { code: 'US', name: 'United States', currency: 'USD', isDefault: true },
  { code: 'IN', name: 'India', currency: 'INR' },
  { code: 'AU', name: 'Australia', currency: 'AUD' },
  { code: 'AE', name: 'UAE', currency: 'AED' },
  { code: 'NZ', name: 'New Zealand', currency: 'NZD' },
  { code: 'UK', name: 'United Kingdom', currency: 'GBP' }  
];

export const getCountryByCode = (code) => {
  return availableCountries.find(country => country.code === code) || availableCountries[0];
};

export const getDefaultCountry = () => {
  return availableCountries.find(country => country.isDefault) || availableCountries[0];
};

export const isCountrySupported = (countryCode) => {
  return availableCountries.some(country => country.code === countryCode);
};

export const getCurrencySymbol = (currencyCode) => {
  const symbols = {
    'USD': '$',
    'INR': '₹',
    'AUD': 'A$',
    'AED': 'AED',
    'NZD': 'NZ$',
    'GBP': '£'   
  };
  return symbols[currencyCode] || currencyCode;
};
